export default {
  setReasons(state, payload) {
    state.reasons = payload;
  },
};
